import { render, staticRenderFns } from "./BreaksConfirmation.vue?vue&type=template&id=7f389fe3&"
import script from "./BreaksConfirmation.vue?vue&type=script&setup=true&lang=js&"
export * from "./BreaksConfirmation.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports